import header_location from "../assets/images/location.png";
import header_notification from "../assets/images/header_notification.png";
import hamburger from "../assets/images/hamburger.png";
import search_icon from "../assets/images/search_icon.png";
import follow_up from "../assets/images/follow_up.png";
import event_scheduled from "../assets/images/event_scheduled.png";
import sidebar_toggle from "../assets/images/sidebar_toggle.png";
import dashboard_icon from "../assets/images/dashboard_icon.png";
import appointment_icon from "../assets/images/appointment_icon.png";
import event_icon from "../assets/images/event_icon.png";
import reports_icon from "../assets/images/reports_icon.png";
import availability_icon from "../assets/images/availability_icon.png";
import rating_icon from "../assets/images/rating_icon.png";
import setting_icon from "../assets/images/setting_icon.png";
import chat_icon from "../assets/images/chat_icon.png";
import help_icon from "../assets/images/help_icon.png";
import logout_icon from "../assets/images/logout_icon.png";
import in_person from "../assets/images/in_person.png";
import navi_right from "../assets/images/navi-right.png";
import total_appointment from "../assets/images/total_appointment.png";
import total_patient_seen from "../assets/images/total_patient_seen.png";
import missed_record from "../assets/images/missed_record.png";
import footer_logo from "../assets/images/footer_logo.png";
import location_mobile from "../assets/images/location_mobile.png";
import empty_stats from "../assets/images/empty_stats.png";
import no_appointment from "../assets/images/no_appointment.png";
import video_icon from "../assets/images/video_icon.png";
import chat from "../assets/images/chat.png";
import audio_call from "../assets/images/audio_call.png";
import no_chart_data from "../assets/images/no_chart_data.png";
import notification_bell from "../assets/images/notification_bell.png";
import no_recent from "../assets/images/no_recent.png";
import export_icon from "../assets/images/export_icon.png";
import calender_icon from "../assets/images/calender_icon.png";
import calender from "../assets/images/calender.png";
import edit_icon from "../assets/images/edit_icon.png";
import prescription_icon from "../assets/images/prescription.png";
import notes_icon from "../assets/images/notes.png";
import video from "../assets/images/video.png";
import voice_call from "../assets/images/voice_call.png";
import chat_new from "../assets/images/chat_new.png";
import user_filled from "../assets/images/user_filled.png";
import edit_appointment from "../assets/images/edit_appointment.png";
import available from "../assets/images/available.png";
import unavailable from "../assets/images/unavailable.png";
import filter from "../assets/images/filter.png";
import profile_success from "../assets/images/profile_success.png";
import profile_error from "../assets/images/profile_error.png";
import slot_error from "../assets/images/slot_error.png";
import slot_success from "../assets/images/slot_success.png";
import manage_unavailable from "../assets/images/manage_unavailable.png";
import delete_unavailable from "../assets/images/delete_unavailable.png";
import phyber_logo_white from "../assets/images/phyber_logo_white.png";
import upload from "../assets/images/upload.png";
import request_reschedule from "../assets/images/request_reschedule.png";
import create_followup from "../assets/images/create_followup.png";
import login_web from "../assets/images/login_web.png";
import login_mobile from "../assets/images/login_mobile.png";
import on_web from "../assets/images/on_web.png";
import failed_Call from "../assets/images/failed_Call.png";
import reschedule_icon from "../assets/images/reschedule-icon.png";

const IMAGES = {
  header_location,
  header_notification,
  hamburger,
  search_icon,
  follow_up,
  event_scheduled,
  sidebar_toggle,
  dashboard_icon,
  appointment_icon,
  event_icon,
  reports_icon,
  availability_icon,
  rating_icon,
  setting_icon,
  chat_icon,
  help_icon,
  logout_icon,
  in_person,
  navi_right,
  total_appointment,
  total_patient_seen,
  missed_record,
  footer_logo,
  location_mobile,
  empty_stats,
  no_appointment,
  video_icon,
  chat,
  audio_call,
  no_chart_data,
  notification_bell,
  no_recent,
  export_icon,
  calender_icon,
  calender,
  edit_icon,
  prescription_icon,
  notes_icon,
  video,
  voice_call,
  chat_new,
  user_filled,
  edit_appointment,
  available,
  unavailable,
  filter,
  profile_success,
  profile_error,
  slot_error,
  slot_success,
  manage_unavailable,
  delete_unavailable,
  phyber_logo_white,
  upload,
  request_reschedule,
  create_followup,
  login_web,
  login_mobile,
  on_web,
  failed_Call,
  reschedule_icon,
};

export default IMAGES;
